import type { PlanVo } from "@/api";

export function isFreePlan(plan: PlanVo) {
  return plan.planCode === "free_plan";
}
